import { post, postJson } from '@/utils/request';

/******** 用户 Start ********/
// 登录
export const login = params => {
  return post(`/app/user/login`, params);
};
// 获取用户信息
export const getUserInfo = id => {
  return post('/user/get', { id });
};
// 获取用户菜单
export const treeData = userId => {
  return post('/function/treeData', { userId: userId });
};
// 获取用户列表
export const getUserList = params => {
  return post('/user/getUserList', params);
};
// 根据角色code获取用户列表
export const getUserListByCode = params => {
  return post('/role/getUserListByCode', params);
};
// 新增/编辑用户
export const saveUser = params => {
  return postJson('/user/save', params);
};
// 删除用户
export const deleteUser = id => {
  return post(`/user/delete/${id}`);
};
// 修改密码
export const changePassword = params => {
  return post('/user/changePassword', params);
};
/******** 用户 End ********/

/******** 部门 Start ********/
// 列表数据
export const getOrgData = params => {
  return post(`/org/treeData`, params);
};
// 详情
export const getOrg = id => {
  return post(`/org/get/${id}`);
};
// 新增/编辑
export const saveOrg = params => {
  return post('/org/save', params);
};
// 删除
export const deleteOrg = id => {
  return post(`/org/delete/${id}`);
};
/******** 部门 End ********/

/******** 岗位 Start ********/

/******** 岗位 End ********/

/******** 角色 Start ********/
// 列表数据
export const getRoleList = params => {
  return post(`/role/getList`, params);
};
// 详情
export const getRole = id => {
  return post(`/role/get/`, { id });
};
// 新增/编辑
export const saveRole = params => {
  return post('/role/save', params);
};
// 删除
export const deleteRole = id => {
  return post(`/role/delete/${id}`);
};
// 根据角色获取菜单列表
export const getFunctionDataByRole = roleId => {
  return post(`/function/listTree/${roleId}`);
};
// 设置角色菜单权限
export const saveRolefunc = params => {
  return post(`/rolefunc/save_batch`, params);
};
// 绑定人员列表 select: 1 已绑定；0 未绑定
export const getRoleUserList = params => {
  return post(`/role/getUserList`, params);
};
// 绑定人员
export const saveRoleUser = params => {
  return post(`/userrole/save`, params);
};
// 移除绑定人员
export const deleteRoleUser = params => {
  return post(`/userrole/deleteUser`, params);
};
/******** 角色 End ********/

/******** 日志 Start ********/

/******** 日志 End ********/
